import { db } from "../../../utils/firebase"
import {
	AMENDMENT_REFERENCE_ALPHABET,
	AMENDMENT_REFERENCE_LENGTH,
	AMENDMENT_REFERENCE_PREFIX,
} from "../../../utils/exports/amendments"

function buildReferenceCandidate() {
	let code = ""
	for (let i = 0; i < AMENDMENT_REFERENCE_LENGTH; i++) {
		const idx = Math.floor(Math.random() * AMENDMENT_REFERENCE_ALPHABET.length)
		code += AMENDMENT_REFERENCE_ALPHABET[idx]
	}
	return `${AMENDMENT_REFERENCE_PREFIX}${code}`
}

/**
 * Mint a unique amendment reference (`GHDA-XXXXXXXX`). The 31⁸ keyspace
 * makes collisions vanishingly rare, but we still check Firestore and
 * retry on the off-chance.
 */
export async function mintAmendmentReference(maxAttempts = 5) {
	for (let attempt = 0; attempt < maxAttempts; attempt++) {
		const reference = buildReferenceCandidate()
		const existing = await db
			.collection("amendments")
			.where("reference", "==", reference)
			.limit(1)
			.get()
		if (existing.empty) return reference
	}
	throw new Error("Unable to mint a unique amendment reference after several attempts.")
}
